// extracted by mini-css-extract-plugin
export var answersBox = "transition-weekly-answers-module--answers-box--00ff7";
export var answersItem = "transition-weekly-answers-module--answers-item--3ad75";
export var answersLabel = "transition-weekly-answers-module--answers-label--2e386";
export var answersList = "transition-weekly-answers-module--answers-list--c066a";
export var answersNumber = "transition-weekly-answers-module--answers-number--00dae";
export var complete = "transition-weekly-answers-module--complete--46eef";
export var container = "transition-weekly-answers-module--container--95ab4";
export var editButton = "transition-weekly-answers-module--edit-button--75619";
export var sent = "transition-weekly-answers-module--sent--0b9f6";
export var textButton = "transition-weekly-answers-module--text-button--45e8a";